/**
 *
 * retryFetch
 * Fetch, retrying on network errors. A network error can mean the server
 * handled the request but the response was lost, so a caller whose request
 * must not run twice, such as creating a payment or a route, passes
 * `retry: false` in the options.
 *
 */

import sleep from './sleep';

const MAX_ATTEMPTS = 5;
const RETRY_DELAY = 1000;

async function retryFetch(uri, options) {
  const { retry = true, ...fetchOptions } = options ?? {};
  const maxAttempts = retry ? MAX_ATTEMPTS : 1;
  let error;
  // eslint-disable-next-line no-plusplus
  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    try {
      // eslint-disable-next-line no-await-in-loop
      return await fetch(uri, fetchOptions);
    } catch (err) {
      error = err;
      if (attempt < maxAttempts) {
        // eslint-disable-next-line no-await-in-loop
        await sleep(RETRY_DELAY);
      }
    }
  }
  // Only the method: headers hold the API key and the body personal data, and
  // the error can reach Sentry through the Redux action context
  error.request = { method: fetchOptions.method || 'GET' };
  throw error;
}

export default retryFetch;
